<h1 mat-dialog-title>{{ 'Order.EditOrderItem' | translate }}</h1>
<div mat-dialog-content>
  <form [formGroup]="editForm">
    <div class="form-container">
      <div class="row">
        <div class="col-md-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Order.List.SubmissionDate' | translate }}</mat-label>
            <input matInput formControlName="submissionDate" />
          </mat-form-field>
        </div>
        <div class="col-md-7">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Order.List.Submitter' | translate }}</mat-label>
            <input matInput formControlName="submitterFullName" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Order.List.Employer' | translate }}</mat-label>
            <input matInput formControlName="employerName" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Order.List.EmployerObject' | translate }}</mat-label>
            <input matInput formControlName="employerObjectName" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Order.List.PositionExpectation' | translate }}</mat-label>
            <input matInput formControlName="positionExpectationName" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Order.List.FromDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="startDate" [min]="minStartDate" readonly />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Order.List.EmployeesNumber' | translate }}</mat-label>
          <input matInput type="number" formControlName="employeesNumber" min="0" [max]="originalEmployeesNumber" />
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row">
  <div class="col">
    <button mat-button class="float-left" (click)="onClose()">{{ 'Cancel' | translate }}</button>
    <button mat-raised-button class="float-right" color="primary" (click)="onSave()">{{ 'Save' | translate }}</button>
  </div>
</div>
